import { extend } from 'lodash'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	session: null,
}

const { actions, reducer } = createSlice({
	name: 'analytics',
	initialState,
	reducers: {
		createSession: (state, { payload }) => {
			const type = payload || 'creation'
			extend(state, {
				session: {
					type,
					startDate: new Date(),
				},
			})
		},
	},
})

export const { createSession } = actions

export default reducer
